import { PrimeIcons } from 'primereact/api'

import { TrialTemplate } from '../../data'

type TemplateDescriptionProps = {
  selectedTemplate?: TrialTemplate
}

const TemplateDescription: React.FC<TemplateDescriptionProps> = ({
  selectedTemplate,
}) => {
  if (!selectedTemplate) return null
  if (!selectedTemplate.Description) return null

  return (
    <div className="flex flex-col mb-2">
      <div className={`${PrimeIcons.INFO_CIRCLE} py-1`} />
      <div className="ml-2">{selectedTemplate.Description}</div>
    </div>
  )
}

export default TemplateDescription
